import { Text } from "@clipboard-health/ui-components";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemAmountProps {
  item: PaymentsListItem;
  compact?: boolean;
}

export function PaymentsListItemAmount(props: PaymentsListItemAmountProps) {
  const { compact = true, item } = props;

  return (
    <Text variant={compact ? "body1" : "h3"} semibold={compact}>
      {formatDollarsAsUsd(item.attributes.amountInCents / 100)}
    </Text>
  );
}
